import {Environment} from '@eitje/api'
import {EnvironmentDropdownItem, OrganisationDropdownItem, BillingInfoDropdownItem} from './dropdown_items'
import {DropdownItem} from '@eitje/web_components'

export const EnvironmentDropdown = ({id}) => {
	const {billing_info_id, organisation_id} = Environment.useFind(id)
	return (
		<>
			<EnvironmentDropdownItem ids={[id]} icon="eye-open" />
			<DropdownItem iconLeft="pencil" t="common.edit" modalLink={`/firms/environments/${id}/edit`} />
			<OrganisationDropdownItem id={organisation_id} />
			<BillingInfoDropdownItem id={billing_info_id} />
		</>
	)
}
